import React from 'react';
import { 
    Container, 
    Paper, 
    Typography, 
    Box, 
    List, 
    ListItem, 
    ListItemIcon, 
    ListItemText,
    Divider,
    Link,
    IconButton
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ChatIcon from '@mui/icons-material/Chat';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate } from 'react-router-dom';
import { useEdition } from './bible/edition';

const About = () => {
    const navigate = useNavigate();
    const edition = useEdition();

    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <IconButton
              onClick={() => navigate(edition.homePath)}
              sx={{ mr: 2 }}
              aria-label="返回首页"
            >
              <HomeIcon />
            </IconButton>
            <Typography variant="h4" component="h1">
              联系我们
            </Typography>
          </Box>

          <Box sx={{ mt: 4 }}>
            <List>
              <ListItem>
                <ListItemIcon>
                  <ChatIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="微信号" secondary="admin_ymnl" />
              </ListItem>

              <Divider variant="inset" component="li" />

              <ListItem>
                <ListItemIcon>
                  <WhatsAppIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="WhatsApp"
                  secondary={
                    <Link
                      href="tel:+6587630819"
                      underline="hover"
                      color="inherit"
                    >
                      +65 8763 0819
                    </Link>
                  }
                />
              </ListItem>

              <Divider variant="inset" component="li" />

              <ListItem>
                <ListItemIcon>
                  <PhoneIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="教会电话"
                  secondary={
                    <Link
                      href="tel:+6564736364"
                      underline="hover"
                      color="inherit"
                    >
                      +65 6473 6364
                    </Link>
                  }
                />
              </ListItem>

              <Divider variant="inset" component="li" />

              <ListItem>
                <ListItemIcon>
                  <EmailIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="电子邮箱"
                  secondary={
                    <Link
                      href="mailto:admin@icc.org.sg"
                      underline="hover"
                      color="inherit"
                    >
                      admin@icc.org.sg
                    </Link>
                  }
                />
              </ListItem>

              <Divider variant="inset" component="li" />
              <ListItem>
                <ListItemIcon>
                  <EmailIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="技术邮箱"
                  secondary={
                    <Link
                      href="mailto:admin@icc.org.sg"
                      underline="hover"
                      color="inherit"
                    >
                      malunsg@gmail.com
                    </Link>
                  }
                />
              </ListItem>

              <Divider variant="inset" component="li" />

              <ListItem>
                <ListItemIcon>
                  <LocationOnIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="教会地址（新加坡）"
                  secondary={
                    <>
                      <Typography variant="body2" paragraph>
                        The Alexcier #03-19, 237 Alexandra Road, Singapore
                        159929
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        【Alexcier大厦离地铁东西线 EW18 Redhill (红山) A出口
                        5分钟路程，紧靠新龙大厦（SiS buiding）】
                      </Typography>
                    </>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" />
              <ListItem>
                <ListItemIcon>
                  <InfoIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="教会简介"
                  secondary="以马内利基督教会（ICC）1999年由在南洋理工大学工作和学习的四个弟兄姐妹开始了家庭聚会。2003年正式注册，并开始自己的主日崇拜。教会开始初期, 在面对着没有教堂、没有全职牧者、没有资金、人员流动大等等困难的时候，我们一直经历着神的神的慈爱和大能，现在教会已有一批十分忠心且委身的弟兄姐妹位。在上帝的指引下，我们始终坚守上帝给我们的呼召--培养基督的门徒、开展在新加坡的中国人、各地移民、华人的事工。"
                />
              </ListItem>
            </List>
          </Box>
        </Paper>
      </Container>
    );
};

export default About; 